import type { ChangeEvent, ReactNode, RefObject } from "react";
// import { SignatureModal } from "../../../components/Form/SignatureModel";
// import { AttachmentSection } from "../../../components/Form/AttachmentSection";
import type { LegalAdviceFormFiveData } from "../../../types/LegalAdvices/LegalAdviceFormFive.type";
import { DatalistInput } from "../components/dataListInput";
// import { FormActionButtons } from "../../../components/Form/FormActionButton";
import { useSettings } from "../../../context/SettingContext";


export interface AttachmentFile {
  name: string;
  [key: string]: any;
}

export interface DetailFormDocumentProps {
  formData: LegalAdviceFormFiveData;
  isEditable: boolean;
  isSigning: boolean;
  sigCanvasRef: RefObject<any>;
  setIsSigning: (isSigning: boolean) => void;
  handleChange: (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  handleSaveSignature: () => void;
  renderDocumentRow: (label: string, fieldName: any) => ReactNode;
  renderDatePicker: (fieldName: any) => ReactNode;

  // Additional props required for action controls inside this component
  isPreview?: boolean;
  // isSubmitting?: boolean;
  // isApproved?: boolean;
  handleBackNavigation: () => void;
  // handleSaveDraft: (e: React.MouseEvent) => void;
  // handleSubmitToSuperior: (e: React.MouseEvent) => void;
 // handleAttachment:(e:React.MouseEvent)=> void;
}

export const LegalDetailFormFiveDocument: React.FC<DetailFormDocumentProps> = ({
  formData,
//   isSigning,
//   sigCanvasRef,
//   setIsSigning,
  handleChange,
//   handleSaveSignature,
  renderDatePicker,
  // isApproved,
  // isSubmitting = false,
  // handleBackNavigation,
  // handleSaveDraft,
  // handleSubmitToSuperior,
  // handleAttachment
}) => {
  // Replace these with your actual option data sources or imports
 const { settings } = useSettings();

//  const isFormSigned = Boolean(
//     formData.signatureImage?.trim() && 
//     (formData.signerName?.trim() || formData.signName?.trim())
//   );

// Map to simple string arrays for your dropdowns/datalists
const OFFICE_OPTIONS = settings?.offices.map((o) => o.name) || [];
// const TOWNSHIP_OPTIONS = settings?.townships.map((t) => t.name) || [];
// const DISTRICT_OPTIONS = settings?.townships.map((t) => t.name) || [];
// const STATE_OPTIONS = settings?.townships.map((t) => t.name) || [];


  return (
        <div className="w-full max-w-[850px] bg-white shadow-lg border border-gray-300 p-12 text-black leading-relaxed relative text-sm md:text-base">
         <div className="absolute top-4 right-4 text-xs font-bold">ဥပရအမှုလိုက်ပုံစံ (၅)</div>
            {/* Header Section */}
            <div className="text-center space-y-2 mt-4">
              <h1 className="text-lg font-bold">ပြည်ထောင်စုသမ္မတမြန်မာနိုင်ငံတော်အစိုးရ</h1>
              <h2 className="text-md font-bold">ပြည်ထောင်စုရှေ့နေချုပ်ရုံး</h2>
              <div className="flex justify-center items-center gap-2">
                <DatalistInput
                  name="office"
                  value={formData.office  || ""}
                  onChange={handleChange}
                  placeholder="ရုံး"
                  options={OFFICE_OPTIONS}
                />
                <span className="text-left font-bold">ရုံး</span>
              </div>
            </div>
    
            {/* Form Title */}
            <div className="text-center mt-6 mb-8">
              <h3 className="font-bold text-base border-b-2 border-black inline-block pb-1">
                ပြစ်မှုဆိုင်ရာအယူခံမှု၊ ပြင်ဆင်မှု၊ အထွေထွေလျှောက်ထားမှု ပြီးပြတ်ချက်ပုံစံ
              </h3>
            </div>
    
            {/* Fields Layout */}
            <div className="space-y-6">
              {/* ၁။ တရားရုံးအမည် */}
              <div className="flex items-start gap-4">
                <span className="w-8 font-bold text-right">၁။</span>
                <div className="flex-1 flex flex-wrap items-center">
                  <span className="font-medium mr-2">တရားရုံးအမည်</span>
                  <input
                    type="text"
                    name="courtName"
                    value={formData.courtName}
                    onChange={handleChange}
                    className="flex-1 min-w-[200px] bg-transparent border-b border-dotted border-black focus:outline-none px-2"
                  />
                </div>
              </div>
    
              {/* ၂။ အယူခံ၊ ပြင်ဆင်၊ အထွေထွေလျှောက်ထားမှုအမှတ် */}
              <div className="flex items-start gap-4">
                <span className="w-8 font-bold text-right">၂။</span>
                <div className="flex-1 flex flex-wrap items-center">
                  <span className="font-medium mr-2">အယူခံ၊ ပြင်ဆင်၊ အထွေထွေလျှောက်ထားမှုအမှတ်</span>
                  <input
                    type="text"
                    name="appealNo"
                    value={formData.appealNo}
                    onChange={handleChange}
                    className="flex-1 min-w-[200px] bg-transparent border-b border-dotted border-black focus:outline-none px-2"
                  />
                </div>
              </div>
    
              {/* ၃။ လျှောက်ထားသူအမည် */}
              <div className="flex items-start gap-4">
                <span className="w-8 font-bold text-right">၃။</span>
                <div className="flex-1 flex flex-wrap items-center">
                  <span className="font-medium mr-2">လျှောက်ထားသူအမည်</span>
                  <input
                    type="text"
                    name="appellantName"
                    value={formData.appellantName}
                    onChange={handleChange}
                    className="flex-1 min-w-[200px] bg-transparent border-b border-dotted border-black focus:outline-none px-2"
                  />
                </div>
              </div>
    
              {/* ၄။ လျှောက်ထားခံရသူအမည် */}
              <div className="flex items-start gap-4">
                <span className="w-8 font-bold text-right">၄။</span>
                <div className="flex-1 flex flex-wrap items-center">
                  <span className="font-medium mr-2">လျှောက်ထားခံရသူအမည်</span>
                  <input
                    type="text"
                    name="respondentName"
                    value={formData.respondentName}
                    onChange={handleChange}
                    className="flex-1 min-w-[200px] bg-transparent border-b border-dotted border-black focus:outline-none px-2"
                  />
                </div>
              </div>
    
              {/* ၅။ မူလတရားရုံးအမည်၊ အမှုအမှတ်... */}
              <div className="flex items-start gap-4">
                <span className="w-8 font-bold text-right">၅။</span>
                <div className="flex-1 space-y-2">
                  <span className="font-medium block">မူလတရားရုံးအမည်၊ အမှုအမှတ် ၊ တရားလိုနှင့်တရားခံ၊ တရားစွဲဆိုသည့် ဥပဒေပုဒ်မ၊ စီရင်ချက်/အမိန့်အကျဉ်းနှင့် ရက်စွဲ</span>
                  <textarea
                    name="originalCourtDetails"
                    value={formData.originalCourtDetails}
                    onChange={handleChange}
                    rows={3}
                    className="w-full p-2 bg-transparent border border-gray-300 rounded focus:outline-none focus:border-black resize-none"
                  />
                </div>
              </div>
    
              {/* ၆။ တစ်ဆင့်မြင့်တရားရုံး အမည်၊ အမှုအမှတ်... */}
              <div className="flex items-start gap-4">
                <span className="w-8 font-bold text-right">၆။</span>
                <div className="flex-1 space-y-2">
                  <span className="font-medium block">တစ်ဆင့်မြင့်တရားရုံး အမည်၊ အမှုအမှတ်၊ လျှောက်ထားသူ နှင့် လျှောက်ထားခံရသူ၊ စီရင်ချက်/အမိန့်အကျဉ်းနှင့် ရက်စွဲ</span>
                  <textarea
                    name="appellateCourtDetails"
                    value={formData.appellateCourtDetails}
                    onChange={handleChange}
                    rows={3}
                    className="w-full p-2 bg-transparent border border-gray-300 rounded focus:outline-none focus:border-black resize-none"
                  />
                </div>
              </div>
    
              {/* ၇။ လိုက်ပါဆောင်ရွက်သော တရားရုံး၏ စီရင်ချက်/အမိန့်အကျဉ်းနှင့် ရက်စွဲ */}
              <div className="flex items-start gap-4">
                <span className="w-8 font-bold text-right">၇။</span>
                <div className="flex-1 space-y-2">
                  <span className="font-medium block">လိုက်ပါဆောင်ရွက်သော တရားရုံး၏ စီရင်ချက်/အမိန့်အကျဉ်းနှင့် ရက်စွဲ</span>
                  <textarea
                    name="intermediateCourtDetails"
                    value={formData.intermediateCourtDetails}
                    onChange={handleChange}
                    rows={3}
                    className="w-full p-2 bg-transparent border border-gray-300 rounded focus:outline-none focus:border-black resize-none"
                  />
                </div>
              </div>
    
              {/* ၈။ အမှုလိုက်ဥပဒေအရာရှိ၏ လျှောက်လဲတင်ပြချက်အကျဉ်း */}
              <div className="flex items-start gap-4">
                <span className="w-8 font-bold text-right">၈။</span>
                <div className="flex-1 space-y-2">
                  <span className="font-medium block">အမှုလိုက်ဥပဒေအရာရှိ၏ လျှောက်လဲတင်ပြချက်အကျဉ်း</span>
                  <textarea
                    name="advocateSubmission"
                    value={formData.advocateSubmission}
                    onChange={handleChange}
                    rows={3}
                    className="w-full p-2 bg-transparent border border-gray-300 rounded focus:outline-none focus:border-black resize-none"
                  />
                </div>
              </div>
    
              {/* ၉။ အမှုလိုက်ဥပဒေအရာရှိ၏ သဘောထားမှတ်ချက် */}
              <div className="flex items-start gap-4">
                <span className="w-8 font-bold text-right">၉။</span>
                <div className="flex-1 space-y-4">
                  <span className="font-medium block">အမှုလိုက်ဥပဒေအရာရှိ၏ သဘောထားမှတ်ချက်</span>
                  <textarea
                    name="advocateOpinion"
                    value={formData.advocateOpinion}
                    onChange={handleChange}
                    rows={3}
                    className="w-full p-2 bg-transparent border border-gray-300 rounded focus:outline-none focus:border-black resize-none"
                  />
    
                  {/* Advocate Sign Panel */}
                  <div className="flex flex-col items-end space-y-2 mt-4">
                    <div className="w-64 space-y-2">
                      <div className="flex items-center">
                        <span className="w-24 text-right text-xs mr-2">လက်မှတ်</span>
                        <div
                        //   onClick={() => handleOpenSignatureModal('advocate')}
                          className="flex-1 bg-transparent border-b border-dotted border-black min-h-[32px] flex items-center justify-center cursor-pointer hover:bg-gray-50 transition relative group"
                        >
                          {formData.signatureImageAdvocate ? (
                            <img src={formData.signatureImageAdvocate} alt="Advocate Signature" className="h-8 object-contain" />
                          ) : (
                            <span className="text-gray-400 text-xs">✍️ လက်မှတ်ထိုးရန်</span>
                          )}
                          {/* {formData.signatureImage && (
                            <button
                              type="button"
                              onClick={handleClearAdvocateSignature}
                              title="လက်မှတ်ရှင်းလင်းမည်"
                              className="absolute -right-6 text-slate-400 hover:text-rose-500 text-xs px-1 font-bold z-10 print:hidden"
                            >
                              ✕
                            </button>
                          )} */}
                        </div>
                      </div>
                      <div className="flex items-center">
                        <span className="w-24 text-right text-xs mr-2">အမည်</span>
                        <input
                          type="text"
                          name="advocateSignName"
                          value={formData.advocateSignName}
                          onChange={handleChange}
                          className="flex-1 bg-transparent border-b border-dotted border-black text-center text-xs focus:outline-none"
                        />
                      </div>
                      <div className="text-center text-xs font-bold py-1">အမှုလိုက်ဥပဒေအရာရှိ</div>
                      <div className="flex items-center">
                        <span className="w-32 shrink-0 whitespace-nowrap text-right text-xs mr-2">တင်ပြသည့်ရက်စွဲ</span>
                        <div className="flex-grow">{renderDatePicker('advocateSignDate')}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
    
              {/* ၁၀။ တာဝန်ခံဥပဒေအရာရှိ၏ သဘောထားမှတ်ချက် */}
              <div className="flex items-start gap-4">
                <span className="w-8 font-bold text-right">၁၀။</span>
                <div className="flex-1 space-y-4">
                  <span className="font-medium block">တာဝန်ခံဥပဒေအရာရှိ၏ သဘောထားမှတ်ချက်</span>
                  <textarea
                    name="responsibleOfficerOpinion"
                    value={formData.responsibleOfficerOpinion}
                    onChange={handleChange}
                    rows={3}
                    className="w-full p-2 bg-transparent border border-gray-300 rounded focus:outline-none focus:border-black resize-none"
                  />
    
                  {/* Responsible Officer Sign Panel */}
                  <div className="flex flex-col items-end space-y-2 mt-4">
                    <div className="w-64 space-y-2">
                      <div className="flex items-center">
                        <span className="w-24 text-right text-xs mr-2">လက်မှတ်</span>
                        <div
                        //   onClick={() => handleOpenSignatureModal('officer')}
                          className="flex-1 bg-transparent border-b border-dotted border-black min-h-[32px] flex items-center justify-center cursor-pointer hover:bg-gray-50 transition relative group"
                        >
                          {formData.signatureImageOfficer ? (
                            <img src={formData.signatureImageOfficer} alt="Officer Signature" className="h-8 object-contain" />
                          ) : (
                            <span className="text-gray-400 text-xs">✍️ လက်မှတ်ထိုးရန်</span>
                          )}
                          {formData.signatureImage && (
                            <button
                              type="button"
                            //   onClick={handleClearOfficerSignature}
                              title="လက်မှတ်ရှင်းလင်းမည်"
                              className="absolute -right-6 text-slate-400 hover:text-rose-500 text-xs px-1 font-bold z-10 print:hidden"
                            >
                              ✕
                            </button>
                          )}
                        </div>
                      </div>
                      <div className="flex items-center">
                        <span className="w-24 text-right text-xs mr-2">အမည်</span>
                        <input
                          type="text"
                          name="responsibleOfficerSignName"
                          value={formData.responsibleOfficerSignName}
                          onChange={handleChange}
                          className="flex-1 bg-transparent border-b border-dotted border-black text-center text-xs focus:outline-none"
                        />
                      </div>
                      <div className="text-center text-xs font-bold py-1">တာဝန်ခံဥပဒေအရာရှိ</div>
                      <div className="flex items-center">
                        <span className="w-32 shrink-0 whitespace-nowrap text-right text-xs mr-2">တင်ပြသည့်ရက်စွဲ</span>
                        <div className="flex-grow">{renderDatePicker('responsibleOfficerSignDate')}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
    
              <div className="text-xs text-gray-600 border-t border-gray-200 pt-2 font-sans font-semibold">
                မှတ်ချက်။ ခရိုင်ဥပဒေရုံးက လိုက်ပါဆောင်ရွက်သော အမှုများကို အမှတ်စဉ် ၁၀ ထိ အသုံးပြုရန်။
              </div>
    
              {/* ၁၁။ တိုင်းဒေသကြီး/ပြည်နယ်ဥပဒေချုပ်၏ သဘောထားမှတ်ချက် */}
              <div className="flex items-start gap-4">
                <span className="w-8 font-bold text-right">၁၁။</span>
                <div className="flex-1 space-y-4">
                  <span className="font-medium block">တိုင်းဒေသကြီး / ပြည်နယ်ဥပဒေချုပ်၏ သဘောထားမှတ်ချက်</span>
                  <textarea
                    name="stateRegionOpinion"
                    value={formData.stateRegionOpinion}
                    onChange={handleChange}
                    rows={3}
                    className="w-full p-2 bg-transparent border border-gray-300 rounded focus:outline-none focus:border-black resize-none"
                  />
    
                  {/* State/Region Sign Panel */}
                  <div className="flex flex-col items-end space-y-2 mt-4">
                    <div className="w-72 space-y-2">
                      <div className="flex items-center">
                        <span className="w-28 text-right text-xs mr-2">လက်မှတ်</span>
                        <div
                        //   onClick={() => handleOpenSignatureModal('stateRegion')}
                          className="flex-1 bg-transparent border-b border-dotted border-black min-h-[32px] flex items-center justify-center cursor-pointer hover:bg-gray-50 transition relative group"
                        >
                          {formData.signatureImageStateRegion ? (
                            <img src={formData.signatureImageStateRegion} alt="State Region Signature" className="h-8 object-contain" />
                          ) : (
                            <span className="text-gray-400 text-xs">✍️ လက်မှတ်ထိုးရန်</span>
                          )}
                          {/* {formData.signatureImage && (
                            <button
                              type="button"
                              onClick={handleClearStateSignature}
                              title="လက်မှတ်ရှင်းလင်းမည်"
                              className="absolute -right-6 text-slate-400 hover:text-rose-500 text-xs px-1 font-bold z-10 print:hidden"
                            >
                              ✕
                            </button>
                          )} */}
                        </div>
                      </div>
                      <div className="flex items-center">
                        <span className="w-28 text-right text-xs mr-2">အမည်</span>
                        <input
                          type="text"
                          name="stateRegionSignName"
                          value={formData.stateRegionSignName}
                          onChange={handleChange}
                          className="flex-1 bg-transparent border-b border-dotted border-black text-center text-xs focus:outline-none"
                        />
                      </div>
                      <div className="text-center text-xs font-bold py-1">တိုင်းဒေသကြီး/ပြည်နယ်ဥပဒေချုပ်</div>
                      <div className="flex items-center">
                        <span className="w-32 shrink-0 whitespace-nowrap text-right text-xs mr-2">တင်ပြသည့်ရက်စွဲ</span>
                        <div className="flex-grow">{renderDatePicker('stateRegionSignDate')}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
    
              <div className="text-xs text-gray-600 border-t border-gray-200 pt-2 font-sans font-semibold">
                မှတ်ချက်။ တိုင်းဒေသကြီး/ပြည်နယ်ဥပဒေရုံးက လိုက်ပါဆောင်ရွက်သော အမှုများကို အမှတ်စဉ် ၁၁ ထိအသုံးပြုရန်။
              </div> 
            </div>

          </div>
  );
};